// Live clock — 1s tick for the kiosk top bar + idle screen (mockup
// pdks-shared.jsx useNow port). One module-level ticker is shared by every
// consumer via useSyncExternalStore, so the top bar and idle clock read the
// same `now` off a SINGLE setInterval (no per-hook timers, no drift). The
// interval starts with the first subscriber and stops with the last.

import { useSyncExternalStore } from "react";

let now = new Date();
let timer: ReturnType<typeof setInterval> | null = null;
const listeners = new Set<() => void>();

function subscribe(onChange: () => void): () => void {
  listeners.add(onChange);
  if (timer === null) {
    timer = setInterval(() => {
      now = new Date();
      for (const listener of listeners) listener();
    }, 1000);
  }
  return () => {
    listeners.delete(onChange);
    if (listeners.size === 0 && timer !== null) {
      clearInterval(timer);
      timer = null;
    }
  };
}

export function useNow(): Date {
  return useSyncExternalStore(subscribe, () => now);
}
